module.exports = __webpack_public_path__ + "img/logo-principal.3a00c287.png";